import Loadable from "react-loadable";

import { Loading } from "../../common/navigation";

const Calendar = Loadable({
  loader: () => import("./components/calendar"),
  loading: Loading
});

const CalendarDetails = Loadable({
  loader: () => import("./components/calendar_detail"),
  loading: Loading
});

export const routes = [
  {
    path: '/calendar',
    exact: true,
    name: 'calendar',
    component: Calendar,
    // "permission": {
    //   "contactype": [
    //     "affiliate",
    //     "student",
    //     "faculty"
    //   ],
    //   "group": [

    //   ]
    // },
  },
  {
    path: '/calendar/calendar_details/:id',
    exact: true,
    name: 'calendar details',
    component: CalendarDetails,
    // "permission": {
    //   "contactype": [
    //     "affiliate",
    //     "student",
    //     "faculty"
    //   ],
    //   "group": [

    //   ]
    // },
  }
];
